import React, { useState } from "react";
import {
  emailRegex,
  ERROR_FIELDS,
  error_state_check_fn,
  FORM_DATA,
  NUMBER_REGEX,
  postalCodeRegex,
  SERVER_BASE_URL,
} from "../utils";
import { Button, Card, Flex, message } from "antd";
import Branch from "../forms/admin/BranchDetails";
import Contract from "../forms/admin/Contract";
import PrimaryContacts from "../forms/admin/Contacts";
import PlatformUserLogin from "../forms/admin/PlatformUserLogin";
import ErrorOmission from "../forms/admin/ErrorOmission";
import Acknowledgement from "../forms/admin/Acknowledgement";
import TextField from "../components/TextField";
import axios from "axios";
import { v4 as uuidv4 } from "uuid";
import dayjs from "dayjs";
import InitialAdmin from "../forms/admin";
import AdminButton from "../forms/admin/Button";

const Admin = () => {
  let application_number = window.sessionStorage.getItem("application_number");

  const [valid, setValid] = useState(false);
  const [authData, setAuthData] = useState({
    server_id: "",
    application_number: "",
    loading: false,
  });

  const [data, setData] = useState(FORM_DATA);
  const [error, setError] = useState(ERROR_FIELDS);
  const [redbox, setRedbox] = useState(false);
  const [page, setPage] = useState(1);
  const [btnLoading, setBtnLoading] = useState(false);

  const handleInputChange = (e) => {
    let { name, value } = e.target;
    value.trim();

    const custom = e.target.getAttribute("data-custom");

    if (custom === "phone") {
      if (value.length > 14) {
        return;
      }

      //krishnaja
      let formattedValue = value;
      setData({ ...data, [name]: formattedValue });
      let NumOnly = value.replace(/\D/g, "");

      if (NumOnly.length != 10) {
        // setError({ ...error, [name]: true });
      } else {
        // setError({ ...error, [name]: false });
      }
      formattedValue = NumOnly;

      if (NumOnly.length <= 3) {
        formattedValue = `(${NumOnly}`;
        setData({ ...data, [name]: formattedValue });
      } else if (NumOnly.length <= 6) {
        formattedValue = `(${NumOnly.slice(0, 3)}) ${NumOnly.slice(3)}`;
        setData({ ...data, [name]: formattedValue });
      } else if (NumOnly.length <= 10) {
        formattedValue = `(${NumOnly.slice(0, 3)}) ${NumOnly.slice(
          3,
          6
        )}-${NumOnly.slice(6)}`;
        setData({ ...data, [name]: formattedValue });
      }

      //current code
      // if (!NUMBER_REGEX.test(value)) {
      //   return;
      // }
      // if (value.length === 10) {
      //   setData({ ...data, [name]: value });
      //   setError({ ...error, [name]: false });
      // } else {
      //   setData({ ...data, [name]: value });
      //   setError({ ...error, [name]: true });
      // }

      return;
    }

    if (custom === "postal_code") {
      if (postalCodeRegex.test(value)) {
        setData({ ...data, [name]: value });

        // setError({ ...error, [name]: false });
      } else {
        setData({ ...data, [name]: value });

        // setError({ ...error, [name]: true });
      }

      return;
    }

    if (custom === "email") {
      if (emailRegex.test(value)) {
        setData({ ...data, [name]: value });
        // setError({ ...error, [name]: false });
      } else {
        setData({ ...data, [name]: value });
        // setError({ ...error, [name]: true });
      }

      return;
    }

    if (custom === "number") {
      if (!value) {
        setData({ ...data, [name]: value });
        // setError({ ...error, [name]: true });
      } else if (NUMBER_REGEX.test(value)) {
        setData({ ...data, [name]: value });
        // setError({ ...error, [name]: false });
      }
      return;
    }

    setData({ ...data, [name]: value });

    if (error.hasOwnProperty(name)) {
      if (value) {
        // setError({ ...error, [name]: false });
      } else {
        // setError({ ...error, [name]: true });
      }
    }
  };

  const handleCheckbox = (e) => {
    let { name, checked } = e.target;

    setData({ ...data, [name]: checked });

    if (checked) {
      // setError({ ...error, [name]: false });
    } else {
      // setError({ ...error, [name]: true });
    }
  };

  const handleSelect = ({ name, value }) => {
    setData({ ...data, [name]: value });

    if (error.hasOwnProperty(name)) {
      if (value) {
        // setError({ ...error, [name]: false });
      } else {
        // setError({ ...error, [name]: true });
      }
    }
  };

  const validateapplication = async () => {
    setAuthData({ ...authData, loading: true });

    await axios
      .post(`${SERVER_BASE_URL}/application/validate_application_by_admin`, {
        application_number: authData.application_number,
        server_id: authData.server_id,
      })
      .then((response) => {
        console.log(response);

        if (response.data?.success === false) {
          message.error(response.data?.message);
          return;
        }

        window.sessionStorage.setItem("application_id", authData.server_id);
        window.sessionStorage.setItem(
          "application_number",
          authData?.application_number
        );

        let application = response.data?.data?.application;
        let clone_data = {},
          error_clone = {};

        // if (application.registration === "Download Registration Form") {
        //   clone_data = { ...data };
        //   error_clone = { ...error };

        //   // setError({
        //   //   ...error,
        //   //   register_as: error_state_check_fn(application?.registration),
        //   //   download_op_name: error_state_check_fn(application?.operating_name),
        //   //   download_legal_broker_name: error_state_check_fn(
        //   //     application?.legal_name_of_brokerage
        //   //   ),
        //   //   download_gen_email: error_state_check_fn(
        //   //     application?.general_email
        //   //   ),
        //   //   download_ho_phone: error_state_check_fn(
        //   //     application?.head_office_phone
        //   //   ),
        //   // });

        //   setData({
        //     ...data,
        //     register_as: application?.registration,
        //     download_op_name: application?.operating_name,
        //     download_legal_broker_name: application?.legal_name_of_brokerage,
        //     download_gen_email: application?.general_email,
        //     download_ho_phone: application?.head_office_phone,
        //   });

        //   console.log(error_clone, clone_data);

        //   setValid(true);

        //   return;
        // }

        clone_data.register_as = application?.registration;

        clone_data.legal_name_of_brokage = application?.legal_name_of_brokerage;
        clone_data.operating_name = application?.operating_name;
        clone_data.ho_phone_number = application?.head_office_phone;
        clone_data.ho_street = application?.head_office_street;
        clone_data.ho_line2 = application?.head_office_line2;
        clone_data.ho_city = application?.head_office_city;
        clone_data.ho_province = application?.head_office_province;
        clone_data.ho_pc = application?.head_office_pc;
        clone_data.ho_country = application?.head_office_country;
        clone_data.is_ho_the_branch = application?.is_head_office_the_branch;
        clone_data.no_mga = application?.no_mga;
        clone_data.pl_first_name = application?.personal_line_first_name;
        clone_data.pl_last_name = application?.personal_line_last_name;
        clone_data.pl_title = application?.personal_line_title;
        clone_data.pl_email = application?.personal_line_email;
        clone_data.pl_phone = application?.personal_line_phone;
        clone_data.cra_first_name = application?.cra_first_name;
        clone_data.cra_last_name = application?.cra_last_name;
        clone_data.cra_title = application?.cra_title;
        clone_data.cra_email = application?.cra_email;
        clone_data.cra_phone = application?.cra_phone;
        clone_data.acc_first_name = application?.accounting_first_name;
        clone_data.acc_last_name = application?.accounting_last_name;
        clone_data.acc_title = application?.accounting_title;
        clone_data.acc_email = application?.accounting_email;
        clone_data.acc_phone = application?.accounting_phone;
        clone_data.marketing_email = application?.marketing_email;
        clone_data.product_training_email = application?.product_training_email;
        clone_data.consent_forward = application?.agree_to_sending_email;
        clone_data.general_email = application?.general_email;
        clone_data.eo_insurer = application?.e_and_o_insurer;
        clone_data.eo_policy = application?.e_and_o_policy;
        clone_data.eo_limit = application?.e_and_o_policy_limit;
        clone_data.eo_expiry_date =
          application?.e_and_o_expiry_date &&
          dayjs(application?.e_and_o_expiry_date).isValid()
            ? dayjs(application?.e_and_o_expiry_date)
            : "";
        clone_data.has_eando_claims_in_last_5years =
          application?.any_e_and_o_claims_in_5years === true
            ? "Yes"
            : application?.any_e_and_o_claims_in_5years === false
            ? "No"
            : "";
        clone_data.eando_claim_details = application?.e_and_o_claims_details;
        clone_data.cyber_insurer = application?.cyber_insurer;
        clone_data.cyber_limit = application?.cyber_limit;
        clone_data.any_licensce_suspended =
          application?.any_license_suspended === true
            ? "Yes"
            : application?.any_license_suspended === false
            ? "No"
            : "";
        clone_data.suspended_details = application?.suspended_license_details;
        clone_data.brokerage_reprimanded_in_5years =
          application?.is_brokerage_reprimanded_5years === true
            ? "Yes"
            : application?.is_brokerage_reprimanded_5years === false
            ? "No"
            : "";
        clone_data.reprimand_details = application?.reprimaned_details;
        clone_data.terms_agreed = application?.agree_to_acknowledgement;
        clone_data.first_name = application?.first_name;
        clone_data.last_name = application?.last_name;
        clone_data.title = application?.title;
        clone_data.date =
          application?.date && dayjs(application?.date).isValid()
            ? dayjs(application?.date)
            : "";

        clone_data.list_of_branches =
          Array.isArray(application?.branch_details) &&
          application?.branch_details.length
            ? application?.branch_details
            : [
                {
                  key: "1",
                  branch_name: "",
                  address: "",
                  line2: "",
                  country: "Canada",
                  city: "",
                  province: "",
                  postal_code: "",
                  phone: "",
                },
              ];
        clone_data.contracts =
          Array.isArray(application?.contracts) && application?.contracts.length
            ? application?.contracts
            : [{ key: "1", company_name: "", date_appointed: "" }];
        clone_data.mga =
          Array.isArray(application?.mga) && application?.mga.length
            ? application?.mga
            : [{ key: "1", mga_name: "", annual_premium: "" }];
        clone_data.user_accounts =
          Array.isArray(application?.user_accounts) &&
          application?.user_accounts.length
            ? application?.user_accounts
            : [
                {
                  key: "1",
                  first_name: "",
                  last_name: "",
                  email: "",
                  title: "",
                  branch_city: "",
                },
              ];
        clone_data.licensing =
          Array.isArray(application?.licensing) && application?.licensing.length
            ? application?.licensing
            : [{ key: "1", province: "", license: "", expiry_date: "" }];

        error_clone.register_as = error_state_check_fn(
          application?.registration
        );

        error_clone.legal_name_of_brokage = error_state_check_fn(
          application?.legal_name_of_brokerage
        );
        error_clone.ho_phone_number = error_state_check_fn(
          application?.head_office_phone
        );
        error_clone.ho_street = error_state_check_fn(
          application?.head_office_street
        );
        error_clone.ho_line2 = false;
        error_clone.ho_city = error_state_check_fn(
          application?.head_office_city
        );
        error_clone.ho_province = error_state_check_fn(
          application?.head_office_province
        );
        error_clone.ho_pc = error_state_check_fn(application?.head_office_pc);
        error_clone.ho_country = error_state_check_fn(
          application?.head_office_country
        );
        error_clone.pl_first_name = error_state_check_fn(
          application?.personal_line_first_name
        );
        error_clone.pl_last_name = error_state_check_fn(
          application?.personal_line_last_name
        );
        error_clone.pl_title = error_state_check_fn(
          application?.personal_line_title
        );
        error_clone.pl_email = error_state_check_fn(
          application?.personal_line_email
        );
        error_clone.pl_phone = error_state_check_fn(
          application?.personal_line_phone
        );
        error_clone.cra_first_name = error_state_check_fn(
          application?.cra_first_name
        );
        error_clone.cra_last_name = error_state_check_fn(
          application?.cra_last_name
        );
        error_clone.cra_title = error_state_check_fn(application?.cra_title);
        error_clone.cra_email = error_state_check_fn(application?.cra_email);
        error_clone.cra_phone = error_state_check_fn(application?.cra_phone);
        error_clone.acc_first_name = error_state_check_fn(
          application?.accounting_first_name
        );
        error_clone.acc_last_name = error_state_check_fn(
          application?.accounting_last_name
        );
        error_clone.acc_title = error_state_check_fn(
          application?.accounting_title
        );
        error_clone.acc_email = error_state_check_fn(
          application?.accounting_email
        );
        error_clone.acc_phone = error_state_check_fn(
          application?.accounting_phone
        );
        error_clone.marketing_email = error_state_check_fn(
          application?.marketing_email
        );
        error_clone.product_training_email = error_state_check_fn(
          application?.product_training_email
        );
        error_clone.consent_forward = error_state_check_fn(
          application?.agree_to_sending_email,
          "checkbox"
        );
        error_clone.general_email = error_state_check_fn(
          application?.general_email
        );
        error_clone.eo_insurer = error_state_check_fn(
          application?.e_and_o_insurer
        );
        error_clone.eo_policy = error_state_check_fn(
          application?.e_and_o_policy
        );
        error_clone.eo_limit = error_state_check_fn(
          application?.e_and_o_policy_limit
        );
        error_clone.eo_expiry_date = error_state_check_fn(
          application?.e_and_o_expiry_date
        );
        error_clone.has_eando_claims_in_last_5years = error_state_check_fn(
          application?.any_e_and_o_claims_in_5years,
          "yes_or_no"
        );
        error_clone.eando_claim_details = error_state_check_fn(
          application?.e_and_o_claims_details
        );
        error_clone.cyber_insurer = error_state_check_fn(
          application?.cyber_insurer
        );
        error_clone.cyber_limit = error_state_check_fn(
          application?.cyber_limit
        );
        error_clone.any_licensce_suspended = error_state_check_fn(
          application?.any_license_suspended,
          "yes_or_no"
        );
        error_clone.suspended_details = error_state_check_fn(
          application?.suspended_license_details
        );
        error_clone.brokerage_reprimanded_in_5years = error_state_check_fn(
          application?.is_brokerage_reprimanded_5years,
          "yes_or_no"
        );
        error_clone.reprimand_details = error_state_check_fn(
          application?.reprimaned_details
        );
        error_clone.terms_agreed = error_state_check_fn(
          application?.agree_to_acknowledgement,
          "checkbox"
        );
        error_clone.first_name = error_state_check_fn(application?.first_name);
        error_clone.last_name = error_state_check_fn(application?.last_name);
        error_clone.title = error_state_check_fn(application?.title);
        error_clone.date = error_state_check_fn(application?.date);

        error_clone.list_of_branches = [
          {
            key: "1",
            branch_name: undefined,
            address: undefined,
            country: false,
            city: undefined,
            province: undefined,
            postal_code: undefined,
            phone: undefined,
          },
        ];
        error_clone.contracts = [
          { key: "1", company_name: undefined, date_appointed: undefined },
        ];
        error_clone.mga = [
          { key: "1", mga_name: undefined, annual_premium: undefined },
        ];
        error_clone.user_accounts = [
          {
            key: "1",
            first_name: undefined,
            last_name: undefined,
            email: undefined,
            title: undefined,
            branch_city: undefined,
          },
        ];
        error_clone.licensing = [
          {
            key: "1",
            province: undefined,
            license: undefined,
            expiry_date: undefined,
          },
        ];

        for (let i = 0; i < application?.contracts.length; i++) {
          error_clone.contracts[i] = error_clone.contracts[i] || {};

          let key = uuidv4();
          let date_appointed = clone_data.contracts[i].date_appointed;

          clone_data.contracts[i].date_appointed =
            date_appointed && dayjs(date_appointed).isValid()
              ? dayjs(date_appointed)
              : "";
          error_clone.contracts[i].key = key;
          clone_data.contracts[i].key = key;
          error_clone.contracts[i].company_name = error_state_check_fn(
            application.contracts[i]?.company_name
          );
          error_clone.contracts[i].date_appointed =
            error_state_check_fn(date_appointed);
        }

        for (let i = 0; i < application?.branch_details.length; i++) {
          error_clone.list_of_branches[i] =
            error_clone.list_of_branches[i] || {};

          // console.log(error_clone.list_of_branches[i]);

          let key = uuidv4();

          error_clone.list_of_branches[i].key = key;
          clone_data.list_of_branches[i].key = key;

          console.log(error_clone.list_of_branches[i].key);

          error_clone.list_of_branches[i].branch_name = error_state_check_fn(
            application.branch_details[i]?.branch_name
          );

          error_clone.list_of_branches[i].address = error_state_check_fn(
            application.branch_details[i]?.address
          );
          error_clone.list_of_branches[i].country = false;
          error_clone.list_of_branches[i].city = error_state_check_fn(
            application.branch_details[i]?.city
          );
          error_clone.list_of_branches[i].province = error_state_check_fn(
            application.branch_details[i]?.province
          );
          error_clone.list_of_branches[i].postal_code = error_state_check_fn(
            application.branch_details[i]?.postal_code
          );
          error_clone.list_of_branches[i].phone = error_state_check_fn(
            application.branch_details[i]?.phone
          );
        }

        for (let i = 0; i < application?.mga.length; i++) {
          error_clone.mga[i] = error_clone.mga[i] || {};

          let key = uuidv4();
          error_clone.mga[i].key = key;
          clone_data.mga[i].key = key;
          error_clone.mga[i].mga_name = error_state_check_fn(
            application.mga[i]?.mga_name
          );
          error_clone.mga[i].annual_premium = error_state_check_fn(
            application.mga[i]?.annual_premium
          );
        }

        for (let i = 0; i < application?.user_accounts.length; i++) {
          error_clone.user_accounts[i] = error_clone.user_accounts[i] || {};

          let key = uuidv4();
          error_clone.user_accounts[i].key = key;
          clone_data.user_accounts[i].key = key;
          error_clone.user_accounts[i].first_name = error_state_check_fn(
            application.user_accounts[i]?.first_name
          );
          error_clone.user_accounts[i].last_name = error_state_check_fn(
            application.user_accounts[i]?.last_name
          );
          error_clone.user_accounts[i].title = error_state_check_fn(
            application.user_accounts[i]?.title
          );
          error_clone.user_accounts[i].branch_city = error_state_check_fn(
            application.user_accounts[i]?.branch_city
          );
          error_clone.user_accounts[i].email = error_state_check_fn(
            application.user_accounts[i]?.email
          );
        }

        for (let i = 0; i < application?.licensing.length; i++) {
          error_clone.licensing[i] = error_clone.licensing[i] || {};

          let key = uuidv4();
          let expiry_date = application.licensing[i]?.expiry_date;

          clone_data.licensing[i].expiry_date =
            expiry_date && dayjs(expiry_date).isValid ? dayjs(expiry_date) : "";
          error_clone.licensing[i].key = key;
          clone_data.licensing[i].key = key;
          error_clone.licensing[i].province = error_state_check_fn(
            application.licensing[i]?.province
          );
          error_clone.licensing[i].license = error_state_check_fn(
            application.licensing[i]?.license
          );
          error_clone.licensing[i].expiry_date =
            error_state_check_fn(expiry_date);
        }

        console.log(error_clone);

        // setError(error_clone);
        setData(clone_data);
        setValid(true);

        // error_clone.list_of_branches =
        //   application?.branch_details.setData(clone_data);
      })
      .catch((error) => {
        console.log(error);
      })
      .finally(() => {
        setAuthData({ ...authData, loading: false });
      });
  };

  console.log(data, error);

  return (
    <div>
      {valid ? (
        <div className="quote_app">
          <div className={`quote ${redbox ? "error_quote" : ""}`}>
            {/* <ProgressBar page={page} data={data} /> */}

            {application_number ? (
              <div
                className="steps"
                style={{
                  padding: "1.5rem 1rem 0",
                  justifyContent: "flex-end",
                }}
              >
                <p>Application NO: {application_number}</p>
              </div>
            ) : (
              ""
            )}

            <div className="quote_container">
              <div className="">
                <InitialAdmin
                  data={data}
                  setData={setData}
                  handleInputChange={handleInputChange}
                  error={error}
                  handleSelect={handleSelect}
                />
                <Branch
                  data={data}
                  setData={setData}
                  error={error}
                  setError={setError}
                />
                <Contract
                  data={data}
                  setData={setData}
                  handleInputChange={handleInputChange}
                  error={error}
                  setError={setError}
                />
                <PrimaryContacts
                  data={data}
                  setData={setData}
                  handleInputChange={handleInputChange}
                  error={error}
                  setError={setError}
                  handleCheckbox={handleCheckbox}
                />
                <PlatformUserLogin
                  data={data}
                  setData={setData}
                  handleInputChange={handleInputChange}
                  error={error}
                  setError={setError}
                />
                <ErrorOmission
                  data={data}
                  setData={setData}
                  handleInputChange={handleInputChange}
                  error={error}
                  setError={setError}
                />
                <Acknowledgement
                  data={data}
                  setData={setData}
                  handleInputChange={handleInputChange}
                  error={error}
                  handleCheckbox={handleCheckbox}
                  setError={setError}
                />

                {/* <SuccessPage /> */}
              </div>

              <AdminButton
                page={page}
                setPage={setPage}
                data={data}
                setData={setData}
                error={error}
                setError={setError}
                redbox={redbox}
                setRedbox={setRedbox}
                btnLoading={btnLoading}
                setBtnLoading={setBtnLoading}
              />
            </div>
          </div>
        </div>
      ) : (
        <Flex
          justify="center"
          align="center"
          style={{ minHeight: "100vh", padding: "1rem" }}
        >
          <Card
            title="Admin Login"
            style={{ maxWidth: "500px", width: "100%" }}
          >
            <Flex vertical gap={16}>
              <TextField
                label="Server ID"
                name="server_id"
                value={authData.server_id}
                handleChange={(e) => {
                  setAuthData({ ...authData, server_id: e.target.value });
                }}
              />{" "}
              <TextField
                label="Application Number"
                name={"application_number"}
                value={authData.application_number}
                handleChange={(e) => {
                  setAuthData({
                    ...authData,
                    application_number: e.target.value,
                  });
                }}
              />
              <Button
                style={{ width: "fit-content", margin: "auto" }}
                type="primary"
                disabled={!authData.server_id || !authData.application_number}
                loading={authData.loading}
                onClick={validateapplication}
              >
                Submit
              </Button>
            </Flex>
          </Card>
        </Flex>
      )}
    </div>
  );
};

export default Admin;
